
import Vue from 'vue'

export default Vue.extend({
  name: 'ApplicationSVG',
  props: {
    color: {
      type: String,
      required: true
    }
  }
})
